import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedLayout, AdminOnly } from "@/components/core/AppLayout";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import ClientsPage from "@/pages/ClientsPage";
import ClientDetailPage from "@/pages/ClientDetailPage";
import TasksPage from "@/pages/TasksPage";
import CalendarPage from "@/pages/CalendarPage";
import UsersPage from "@/pages/UsersPage";
import ProfilePage from "@/pages/ProfilePage";
import PortalPage from "@/pages/PortalPage";
import MyCalendarPage from "@/pages/MyCalendarPage";
import DataAdminPage from "@/pages/DataAdminPage";
import InvoicesPage from "@/pages/InvoicesPage";
import ReportDraftsPage from "@/pages/ReportDraftsPage";
import SitoWebPage from "@/pages/SitoWebPage";
import { SiteLayout } from "@/site/SiteLayout";
import HomePage from "@/site/HomePage";
import CaseDetailPage from "@/site/CaseDetailPage";
import { AreaClientiPage, PrivacyPage } from "@/site/InfoPages";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/password-dimenticata" element={<ForgotPasswordPage />} />
          <Route path="/reimposta-password" element={<ResetPasswordPage />} />
          <Route path="/portale/:token" element={<PortalPage />} />
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/case-history/:slug" element={<CaseDetailPage />} />
            <Route path="/area-clienti" element={<AreaClientiPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
          </Route>
          <Route element={<ProtectedLayout />}>
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/clienti" element={<ClientsPage />} />
            <Route path="/clienti/:id" element={<ClientDetailPage />} />
            <Route path="/task" element={<TasksPage />} />
            <Route path="/calendario" element={<CalendarPage />} />
            <Route path="/il-mio-calendario" element={<MyCalendarPage />} />
            <Route path="/soci" element={<AdminOnly><UsersPage /></AdminOnly>} />
            <Route path="/amministrazione/fatture" element={<InvoicesPage />} />
            <Route path="/report-da-inviare" element={<ReportDraftsPage />} />
            <Route path="/sito-web" element={<SitoWebPage />} />
            <Route path="/amministrazione/dati" element={<AdminOnly><DataAdminPage /></AdminOnly>} />
            <Route path="/profilo" element={<ProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton toastOptions={{ style: { fontFamily: "Inter, sans-serif", background: "#A6DAFC", borderColor: "#5FB3EA", color: "#0A1128" } }} />
    </AuthProvider>
  );
}

export default App;
